import { useEffect } from 'react';
import { Box } from '@nimbus-ds/components';
import { useQuery } from 'App/hooks';
import { IonPageStratus } from 'commons/components/IonPageStratus';
import { openWindow } from 'commons/utils/window';
import CloudflareBlockCard from './components/CloudflareBlockCard';

interface CloudflareBlockPageProps {
  isBlocked?: boolean;
  hardBlock: boolean;
  onDismiss: () => Promise<void>;
}

function CloudflareBlockPage({
  onDismiss,
  hardBlock,
  isBlocked = true,
}: Readonly<CloudflareBlockPageProps>) {
  const query = useQuery();
  const backToUrl = query.get('back_to');

  useEffect(() => {
    if (!isBlocked) {
      openWindow(backToUrl || '/admin', false);
    }
  }, [isBlocked, backToUrl]);
  if (!isBlocked) return null;

  const onDismissWithRedirect = async () => {
    await onDismiss();

    if (backToUrl) {
      openWindow(backToUrl || '/admin', false);
    }
  };

  return (
    <IonPageStratus width="small">
      <Box padding="6" display="flex" flexDirection="column" height="100vh">
        <CloudflareBlockCard
          onDismiss={onDismissWithRedirect}
          hardBlock={hardBlock}
        />
      </Box>
    </IonPageStratus>
  );
}

export default CloudflareBlockPage;
